<script setup lang="ts">
import { MetricValue } from '@Shared/utils/types';
import { calculateMetricValue, getMetricColour } from './utility';

const props = defineProps<{
  title?: string;
  orderByMeasure?: MetricValue;
  values?: MetricValue[];
  isLoadingIndicator?: boolean;
}>();

const { title, orderByMeasure, values } = toRefs(props);

const measureValue = computed(() => {
  return calculateMetricValue(orderByMeasure.value?.value, orderByMeasure.value?.metricType, 'N/A');
});

const displayValues = computed(() => {
  return values.value?.map((v: MetricValue) => {
    return { ...v, value: calculateMetricValue(v.value, v.metricType, 'N/A') };
  });
});
</script>
<template>
  <div class="flex flex-col">
    <div class="flex rounded-t bg-#2C3647 justify-center items-center p-4 min-h-0">
      <div class="flex text-white text-xs font-normal font-family[Roboto] uppercase" v-if="!isLoadingIndicator">
        {{ title }}
      </div>
    </div>
    <div class="divide-y divide-slate-200 w-full flex flex-col flex-grow min-h-0">
      <div
        class="flex flex-col bg-white rounded-b flex-grow justify-center min-h-0 py-[4px]"
        v-if="!isLoadingIndicator"
      >
        <div
          class="flex text-#4F4F4F font-normal text-3 xl:text-14px font-family[Roboto] justify-center items-center leading-5"
        >
          {{ orderByMeasure?.label }}
        </div>
        <div
          :style="{
            color: getMetricColour(orderByMeasure?.value, orderByMeasure?.metricType),
          }"
          class="flex font-medium text-3 xl:text-14px font-bold font-family[Roboto] justify-center items-center leading-5"
        >
          {{ measureValue }}
        </div>
      </div>
      <div
        class="flex flex-row bg-white rounded-b items-center divide-x divide-slate-200 w-full min-h-0 leading-5"
        v-if="!isLoadingIndicator && displayValues"
      >
        <div
          v-for="v in displayValues"
          :key="v.label"
          :style="{ width: `calc(100% / ${displayValues.length})` }"
          class="box-border font-medium text-12px text-neutral-600 font-family[Roboto] truncate p-2 text-center"
        >
          {{ v.value }} <span uppercase>{{ v.label }} </span>
        </div>
      </div>
      <div class="flex flex-col px-4 py-2 bg-white rounded-b min-h-0 flex-grow justify-center items-center" v-else>
        <div class="loading-gradient-static h-15 w-40"></div>
      </div>
    </div>
  </div>
</template>
